export default __webpack_public_path__ + "static/media/flag4.885479c1.jpg";